import { Injectable } from '@angular/core';
import { ModalComponent } from './modal.component';
import { fromEvent as observableFromEvent, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Injectable()
export class ModalService {

  private modals: Array<ModalComponent>;
  private overflow_y_status = new Subject<string>();
  public exposedOverflowStatus = this.overflow_y_status.asObservable();

  constructor() {
    this.modals = [];

    observableFromEvent(window, 'resize')
    .pipe(
      debounceTime(500),
      distinctUntilChanged()
    )
    .subscribe(
      (data) => {
        if(/chrome/i.test(navigator.userAgent) && !(matchMedia('(max-width: 568px) and (min-width: 320px) and (orientation: portrait)').matches)) {
          this.calculatePosition();
        }
      }
    );
  }

  registerModal(newModal: ModalComponent): void {
    const modal = this.findModal(newModal.modalId);
    // Delete existing to replace the modal
    if(modal) {
      this.modals.splice(this.modals.indexOf(modal),1);
    }
    this.modals.push(newModal);
  }

  open(modalId: string): void {
    const modal = this.findModal(modalId);
    if(modal) {
      this.overflow_y_status.next('hidden'); // overflow-y of the <main tag in app.component
      modal.isOpen = true;
    }

    if(/chrome/i.test(navigator.userAgent) && !(matchMedia('(max-width: 568px) and (min-width: 320px) and (orientation: portrait)').matches)) {
      setTimeout(() => { this.calculatePosition(); }, 100);
    }
  }

  calculatePosition() {
    const modale = document.querySelector('.modal');
    if(!modale) return;

    const modalPosition = modale.getBoundingClientRect();
    let y = ( modalPosition['y'] - modalPosition.bottom ) / 2;
    const x = ( modalPosition['x'] - modalPosition.right ) / 2;

    if(matchMedia('(max-height: 850px)').matches) y = 0;
    modale['style']['transform'] = `translate3d(${Math.round(x)}px, ${Math.round(y)}px, 0)`;
  }

  close(modalId: string, checkBlocking = false) {
    const modal = this.findModal(modalId);
    if(modal) {
      if(checkBlocking) {
        return;
      }
      this.overflow_y_status.next('auto');  // overflow-y of the <main tag in app.component
      modal.isOpen = false;
    }
  }

  private findModal(modalId: string): ModalComponent {
    for(const modal of this.modals) {
      if(modal.modalId === modalId) {
        return modal;
      }
    }
    return null;
  }
}